import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';

import Layout from '../components/layout/AppMainLayout';
import PrivateRoute from '../util/routing/PrivateRoute';
import { ThemeProvider } from 'styled-components';
import { lazy, Suspense } from 'react';

import { lightTheme, GlobalStyle } from './theme';

import OurWork from '../pages/OurWork';
import PortfolioItem from '../pages/OurWork/Portfolio/PortfolioItem';
import { Contact } from '../pages/Contact';
import { ClientLogin } from '../pages/ClientLogin';
import PrivacyPolicy from '../pages/misc/PrivacyPolicy';
import TermsConditions from '../pages/misc/TermsConditions';
import LegalNoticeCookies from '../pages/misc/LegalNoticeCookies';
import AccountBasedMarketing from '../pages/AccountBasedMarketing';
import Services from '../pages/Services';
import NotFound from '../pages/NotFound';
import ServiceDetail from '../pages/Services/ServiceDetail';
import ServicesRedirect from '../pages/Services/ServicesRedirect';

const LoginPage = lazy(() => import('../pages/auth/Login'));
const Home = lazy(() => import('../pages/Home'));
const About = lazy(() => import('../pages/About'));
// import About from '../pages/About';

const App = () => {
  return (
    <Router>
      <ThemeProvider theme={lightTheme}>
        <GlobalStyle />

        <Suspense fallback={''}>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index path="/" element={<Home />} />
              <Route path="/en" element={<Navigate to="/" replace />} />
              <Route path="/fr" element={<Home />} />
              <Route path="/login" element={<LoginPage />} />

              <Route element={<PrivateRoute />}>
                <Route
                  path="/private"
                  element={<p>this is a private page</p>}
                />
              </Route>

              <Route path="/:lang/about" element={<About />} />
              <Route path="/:lang/a-propos" element={<About />} />

              <Route path="/:lang/nos-realisations" element={<OurWork />} />
              <Route path="/:lang/our-work" element={<OurWork />} />
              <Route path="/:lang/our-work/:slug" element={<PortfolioItem />} />
              <Route
                path="/:lang/nos-realisations/:slug"
                element={<PortfolioItem />}
              />

              <Route path="/:lang/services" element={<Services />} />
              <Route path="/:lang/services/:slug" element={<ServiceDetail />} />
              <Route
                path="/:lang/our-services"
                element={<ServicesRedirect />}
              />
              <Route
                path="/:lang/nos-services"
                element={<ServicesRedirect />}
              />

              <Route path="/:lang/contact" element={<Contact />} />

              <Route path="/:lang/app/login" element={<ClientLogin />} />
              <Route path="/:lang/privacy-policy" element={<PrivacyPolicy />} />
              <Route
                path="/:lang/politique-de-confidentialite"
                element={<PrivacyPolicy />}
              />
              <Route
                path="/:lang/terms-and-conditions"
                element={<TermsConditions />}
              />
              <Route
                path="/:lang/termes-et-conditions"
                element={<TermsConditions />}
              />
              <Route
                path="/:lang/legal-notice-cookies"
                element={<LegalNoticeCookies />}
              />
              <Route
                path="/:lang/mentions-legales-et-cookies"
                element={<LegalNoticeCookies />}
              />
              <Route
                path="/:lang/account-based-marketing"
                element={<AccountBasedMarketing />}
              />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </ThemeProvider>
    </Router>
  );
};

export default App;
